import * as types from '../constants/idpAdminActions';
import {clearStorage, setExtendedAttributes, setMappedCapabilities, setSessionToken} from "../actions/storage";

const initialState = {
  errorMsg: null,
  loginInProgress: false,
  credentials: null,
};

export default function orgs(state = initialState, action = {}) {
  switch (action.type) {
    case types.AUTH_START:
      return {
        ...state,
        errorMsg: null,
        loginInProgress: true
      };
    case types.AUTH_SUCCESS:
      setSessionToken(action.response.authSessionToken);
      return {
        ...state,
        errorMsg: null,
        credentials: action.response,
        loginInProgress: false,
      };
    case types.AUTH_FAIL:
      clearStorage();
      return {
        ...state,
        errorMsg: action.errorMsg,
        credentials: null,
        loginInProgress: false,
      };
    case types.STORE_CAPABILITIES:
      setMappedCapabilities(JSON.stringify(action.mappedCapabilities));
      return {
        ...state
      };
    case types.STORE_EXTENDED_ATTRIBUTES:
      setExtendedAttributes(JSON.stringify(action.extendedAttributes));
      return {
        ...state
      };
    default:
      return state;
  }
}
